import { useState } from 'react';
import { Outlet } from 'react-router-dom';

import { PinEnterPrompt } from '../features/settings/PinEnterPrompt';
import { useDeviceStore } from '../store/device';

// Per plan/03 §Navigation rules: PIN gate on entering Settings, not within.
// Once unlocked for this mount, sub-screens stay open without re-prompting.
// Leaving (navigating away from /settings/*) unmounts this layout, so the
// next visit re-prompts.
//
// First-time use (no PIN set yet) bypasses the gate so the parent can
// configure the app and set a PIN from the hub.
export function SettingsLayout() {
  const pin = useDeviceStore((s) => s.pin);
  const [unlocked, setUnlocked] = useState(pin === null);

  if (!unlocked && pin) {
    return <PinEnterPrompt expected={pin} onSuccess={() => setUnlocked(true)} />;
  }
  return <Outlet />;
}
